
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Classical Conclave </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm raagas-urvashi section-banner-bg-1">
    <div class="container">
        <div class="row justify-content-center align-items-center">

            <div class="sec-title text-center">
                <h2>CLASSICAL CONCLAVE BY <span >नृत्याविष्कार</span></h2>
            </div>

            <div class="row">
                <div class="col-lg-8">

                    <p><strong>Let’s meet you then.</strong></p>

                    <p><b>Topic: नृत्याविष्कार </b></p>
                    <p><b>Date – Saturday, 29<sup>th</sup>April 2023 </b></p>
                    <!-- <p><b>Time – 5:00 pm - Sharp (Grab your seats before time)</b></p> -->
                    <p><b>Venue: वसंतराव देशपांडे हॉल सिव्हिल लाईन्स, नागपूर </b></p>
                </div>
                <div class="col-md-4">
                    <div class="image-effect-2">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ramchandra-gatha .png"
                            alt="GHRSCF" style="width: 100%;">
                    </div>
                </div>
            </div>
        </div>

        <div class="border-line-sm"></div>
        <div class="row">
            <!-- <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Media Coverage</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="media#media_classical"   class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                    <iframe width="100%" height="230" src="https://drive.google.com/file/d/1069W9_-cBzrBgwDIuB6IXFrKgo9RUBHC/preview"   frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

                </div>
            </div> -->
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="photogallery#nrutyavishkar" class="btn button--effect-1"><span>
                                    View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar_ghrscf.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar_ghrscf.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar_ghrscf.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-1.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-1.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-1.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-2.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-2.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-2.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-3.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-3.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-3.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-4.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-4.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-4.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme//nrutyavishkar-5.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-5.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-5.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-5">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Media Coverage</h4>
                            </div>
                        </div>
                        <div class="col-md-7 text-end">
                            <!-- <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                    YouTube link</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                            </a> -->
                        </div>
                    </div>
                    <iframe src="https://drive.google.com/file/d/1AI3ucJ3yw-AkXoD9dqkSo-TsEMfpX6Va/preview" height="250"
                        width="100%"></iframe>
                </div>
            </div>

        </div>
    </div>
</section>
